import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { DivisionCodesTypes } from '../constants/division-codes';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';

type ShipmentLocationSalesArea = IJobsiteSalesArea | IPointOfDeliverySalesArea;

/**
 * Retrieves the jobsite/pod sales area by a division code
 * If division code is not there then returns first item
 */
export const divisionSalesArea = (
  salesAreas: ShipmentLocationSalesArea[],
  divisionCode: DivisionCodesTypes,
): ShipmentLocationSalesArea => {
  const divisionCodeSalesArea = salesAreas.find(
    (item: ShipmentLocationSalesArea) => item['salesArea']['divisionCode'] === divisionCode,
  );
  return divisionCodeSalesArea || salesAreas[0];
};
